module.exports = __webpack_public_path__ + "cloud-infrastructure.3M81E0zD.svg";